module.exports = __webpack_public_path__ + "img/orangutan.02a45e49.png";